import { createFileRoute } from "@tanstack/react-router";
import IsTmsRightForMe from "@/pages/IsTmsRightForMe";
export const Route = createFileRoute("/contents/tms/is-tms-right-for-me")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Is TMS Right For Me? | Candidate Assessment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Find out if TMS is right for your depression. Review candidacy, prior antidepressant requirements, and insurance guidelines in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Is TMS Right For Me? | Candidate Assessment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Find out if TMS is right for your depression. Review candidacy, prior antidepressant requirements, and insurance guidelines in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/tms/is-tms-right-for-me",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/tms/is-tms-right-for-me",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IsTmsRightForMe />;
}
